<div class="wrapper">

    <div class="row">

        <div class="col-sm-12">

            <div class="card bb-panel">

                <form [formGroup]="changePasswordForm" autocomplete="chrome-off" class="col-sm-12" role="form"
                    aria-label="registration form">

                    <div class="form-group">
                        <label><span aria-hidden="true" class="form-field-required-marker">
                                *</span> {{ 'ACCOUNT.CURRENT_PASSWORD_LBL' | translate}}</label>
                        <input [type]="hideCurrentPassword ? 'password' : 'text'" class="form-control"
                            formControlName="current_password" role="textbox" aria-label="first name input field">
                        <span class="eye-pos">
                            <mat-icon class="material-symbols-outlined eye" (click)="hideCurrentPassword = false"
                                *ngIf="hideCurrentPassword">
                                visibility_off
                            </mat-icon>
                            <mat-icon class="material-symbols-outlined eye" (click)="hideCurrentPassword = true"
                                *ngIf="!hideCurrentPassword">
                                visibility
                            </mat-icon>
                        </span>
                        <div *ngIf="submitted && form.current_password.errors" class="invalid-feedback">
                            <div *ngIf="form.current_password.errors.required" role="alert">
                                {{ 'ACCOUNT.CURRENT_PASSWORD_REQURIED' | translate}}
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label><span aria-hidden="true" class="form-field-required-marker">
                                *</span> {{ 'ACCOUNT.NEW_PASSWORD_LBL' | translate}}</label>
                        <input [type]="hide ? 'password' : 'text'" class="form-control" formControlName="new_password"
                            role="textbox" aria-label="first name input field">
                        <span class="eye-pos">
                            <mat-icon class="material-symbols-outlined eye" (click)="hide = false" *ngIf="hide">
                                visibility_off
                            </mat-icon>
                            <mat-icon class="material-symbols-outlined eye" (click)="hide = true" *ngIf="!hide">
                                visibility
                            </mat-icon>
                        </span>
                        <div *ngIf="submitted && form.new_password.errors" class="invalid-feedback">
                            <div *ngIf="form.new_password.errors.required" role="alert">
                                {{ 'ACCOUNT.NEW_PASSWORD_REQURIED' | translate}}</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label><span aria-hidden="true" class="form-field-required-marker">
                                *</span> {{ 'ACCOUNT.CONFIRM_PASSWORD_LBL' | translate}}</label>
                        <input [type]="hideConfirmPassword ? 'password' : 'text'" class="form-control"
                            formControlName="confirm_new_password" role="textbox" aria-label="first name input field">
                        <span class="eye-pos">
                            <mat-icon class="material-symbols-outlined eye" (click)="hideConfirmPassword = false"
                                *ngIf="hideConfirmPassword">
                                visibility_off
                            </mat-icon>
                            <mat-icon class="material-symbols-outlined eye" (click)="hideConfirmPassword = true"
                                *ngIf="!hideConfirmPassword">
                                visibility
                            </mat-icon>
                        </span>
                        <div *ngIf="submitted && form.confirm_new_password.errors" class="invalid-feedback">
                            <div *ngIf="form.confirm_new_password.errors.required" role="alert">
                                {{ 'ACCOUNT.CONFIRM_PASSWORD_REQURIED' | translate}}</div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="row mt-4">
                <div class="col-sm-12">
                    <button class="btn btn-primary govuk-button button-sizer float-right col-12 col-sm-10 col-md-2"
                        type="button" (click)="onSubmit()">{{'COMMON.UPDATE' | translate}}</button>

                </div>
            </div>
        </div>
    </div>
</div>